import { readPersistedSidebarCollapsed } from '@viapeople/components'
import type React from 'react'
import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { ChatWidget } from '../modules/chatbot'
import { maintenanceStore } from '../sharedStores/maintenanceStore'
import { usePageTitle } from '../utils/usePageTitle'
import { AppHeader } from './AppHeader'
import { MaintenanceScreen } from './MaintenanceScreen'
import Sidebar from './Sidebar'

interface LayoutProps {
	children?: React.ReactNode
}

export const Layout: React.FC<LayoutProps> = () => {
	usePageTitle()

	const { isInMaintenance, hasChecked, checkMaintenanceStatus } = maintenanceStore()
	const [sidebarCollapsed, setSidebarCollapsed] = useState(() => readPersistedSidebarCollapsed(true))

	useEffect(() => {
		// Check maintenance status on mount
		checkMaintenanceStatus()
	}, [checkMaintenanceStatus])

	// Wait for maintenance check to complete before rendering
	if (!hasChecked) {
		return null
	}

	// Show maintenance screen if in maintenance mode
	if (isInMaintenance) {
		return <MaintenanceScreen />
	}

	return (
		<div className='flex h-screen'>
			<Sidebar onCollapsedChange={setSidebarCollapsed} />
			<div
				className={`flex-1 flex flex-col overflow-hidden transition-[padding] duration-300 ${
					sidebarCollapsed ? 'pl-15' : 'pl-78'
				}`}>
				<AppHeader />
				<div className='flex-1 overflow-auto'>
					<Outlet />
				</div>
			</div>
			<ChatWidget />
		</div>
	)
}
